import CompanyManagement from "./company-management.page";

export default CompanyManagement;
